import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import router from './routes/index';
import store from './store/index';

import StepBar from "../core/components/StepBar.vue";
import Navigation from "../core/components/Navigation.vue";
import LoadingSpinner from "../core/components/LoadingSpinner.vue";
import Card from "./components/Card.vue";
import RadioButton from "../core/components/RadioButton.vue";
import SaveConfiguration from "./components/SaveConfiguration.vue";
import ImageGallery from "./components/ImageGallery.vue";

window.axios = axios;

Vue.use(VueRouter);

Vue.component('StepBar', StepBar);
Vue.component('Navigation', Navigation);
Vue.component('LoadingSpinner', LoadingSpinner);
Vue.component('Card', Card);
Vue.component('RadioButton', RadioButton);
Vue.component('SaveConfiguration', SaveConfiguration);
Vue.component('ImageGallery', ImageGallery);

const app = new Vue({
    el: '#configurator-app',
    router,
    store,
});